import React from 'react';
import './ticketStyle.css';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
dayjs.extend(customParseFormat);

export const TicketCierreCaja = React.forwardRef(({
    datosCierre,
    infoNegocio = {}
}, ref) => {

    if (!datosCierre) return null;

    const tipoPapel = infoNegocio.anchoTicket || '57mm';

    let anchoContenedor = '57mm';
    let tamañoFuenteBase = '8.5px';
    let tamañoFuenteTitulo = '12px';
    let tamañoFuentePequena = '7.5px';

    if (tipoPapel === '80mm') {
        anchoContenedor = '76mm';
        tamañoFuenteBase = '10px';
        tamañoFuenteTitulo = '14px';
        tamañoFuentePequena = '8.5px';
    }

    const styles = {
        container: {
            width: anchoContenedor,
            padding: '0mm 2mm 15mm 2mm',
            color: '#000',
            fontFamily: 'Arial, Helvetica, sans-serif',
            fontSize: tamañoFuenteBase,
            lineHeight: '1.2',
            backgroundColor: '#fff',
            textTransform: 'uppercase'
        },
        header: { textAlign: 'center', marginBottom: '8px' },
        logoContainer: { display: 'flex', justifyContent: 'center', marginBottom: '5px' },
        logo: { maxWidth: '35mm', filter: 'grayscale(1)' },
        divider: { borderTop: '1px dashed #000', margin: '5px 0' },
        dividerDotted: { borderTop: '1px dotted #888', margin: '3px 0' },
        bold: { fontWeight: 'bold' },
        tituloEmpresa: { fontWeight: '900', fontSize: tamañoFuenteTitulo, marginBottom: '2px' },
        row: { display: 'flex', justifyContent: 'space-between', padding: '2px 0' },
    };

    const calcularDuracionTurno = (inicio, fin) => {
        if (!inicio) return 'N/A';

        // Definimos el formato exacto que viene desde tu base de datos
        const formato = "DD/MM/YYYY hh:mm A";

        // Ahora le decimos a dayjs cómo leer esos strings
        const fechaInicio = dayjs(inicio, formato);
        const fechaFin = fin ? dayjs(fin, formato) : dayjs();

        const diferenciaMinutos = fechaFin.diff(fechaInicio, 'minute');

        if (diferenciaMinutos < 0) return 'Error en fechas';

        const horas = Math.floor(diferenciaMinutos / 60);
        const minutos = diferenciaMinutos % 60;

        return `${horas}H ${minutos}M`;
    };

    return (
        <div ref={ref} id="ticket-print-area" style={styles.container}>
            {/* --- ENCABEZADO ORIGINAL --- */}
            <div style={styles.header}>
                {infoNegocio.logo && (
                    <div style={styles.logoContainer}>
                        <img src={infoNegocio.logo} style={styles.logo} alt="logo" />
                    </div>
                )}
                <div style={{ ...styles.bold, fontSize: tamañoFuenteTitulo, marginBottom: '2px' }}>{infoNegocio.nombre || ''}</div>
                <div style={{ fontWeight: '600' }}>NIT: {infoNegocio.nit || '900.000.000-1'}</div>
                <div style={{ fontWeight: '600' }}>CIERRE DE CAJA</div>
            </div>

            <div style={styles.divider} />

            <div style={{ fontSize: tamañoFuenteBase }}>
                <div style={{ fontWeight: '600' }}>
                    USUARIO: {datosCierre.nombreUsuario || 'N/A'}
                </div>
                <div style={{ fontWeight: '600' }}>
                    FECHA APERTURA: {datosCierre.creado_at || 'N/A'}
                </div>
                <div style={{ fontWeight: '600' }}>
                    FECHA CIERRE: {datosCierre.cierre || dayjs().format('DD/MM/YYYY hh:mm A')}
                </div>
                <div style={{ fontWeight: '600' }}>
                    TIEMPO ABIERTO: {calcularDuracionTurno(datosCierre.creado_at, datosCierre.cierre)}
                </div>
                <div style={{ fontWeight: '600' }}>TURNO: #{datosCierre.id || 'N/A'}</div>
            </div>

            <div style={styles.divider} />

            {/* --- BLOQUE 1: CAJA FÍSICA (Todo lo que afecta billetes) --- */}
            <div style={{ ...styles.bold, textAlign: 'center', marginBottom: '6px', textDecoration: 'underline' }}>
                CUADRE DE CAJA FÍSICA
            </div>

            <div style={styles.row}>
                <span>(+) BASE INICIAL:</span>
                <span>${Number(datosCierre.base_inicial).toLocaleString('es-CO')}</span>
            </div>
            <div style={styles.row}>
                <span>(+) VENTAS EFECTIVO:</span>
                <span>${Number(datosCierre.ventas_efectivo).toLocaleString('es-CO')}</span>
            </div>
            {Number(datosCierre.abonos_efectivo) > 0 && (
                <div style={styles.row}>
                    <span>(+) ABONOS EFECTIVO:</span>
                    <span>${Number(datosCierre.abonos_efectivo).toLocaleString('es-CO')}</span>
                </div>
            )}

            {Number(datosCierre.pagos_proveedores) > 0 && (
                <div style={styles.row}>
                    <span>(-) PAGOS/COMPRAS:</span>
                    <span>-${Number(datosCierre.pagos_proveedores).toLocaleString('es-CO')}</span>
                </div>
            )}
            {Number(datosCierre.gastos) > 0 && (
                <div style={styles.row}>
                    <span>(-) GASTOS DIARIOS:</span>
                    <span>-${Number(datosCierre.gastos).toLocaleString('es-CO')}</span>
                </div>
            )}
            {Number(datosCierre.devoluciones) > 0 && (
                <div style={styles.row}>
                    <span>(-) DEV. EFECTIVO (Caja):</span>
                    <span>-${Number(datosCierre.devoluciones || 0).toLocaleString('es-CO')}</span>
                </div>
            )}

            <div style={styles.dividerDotted} />
            <div style={{ ...styles.row, ...styles.bold, fontSize: tamañoFuenteTitulo, marginTop: '4px' }}>
                <span>EFECTIVO ESPERADO:</span>
                <span>${Number(datosCierre.monto_esperado).toLocaleString('es-CO')}</span>
            </div>

            <div style={styles.divider} />
            <div style={{ ...styles.bold, textAlign: 'center', marginBottom: '4px' }}>
                ARQUEO DE CAJA
            </div>

            <div style={styles.row}>
                <span>EFECTIVO FÍSICO:</span>
                <span>${Number(datosCierre.monto_fisico).toLocaleString('es-CO')}</span>
            </div>

            <div style={{ ...styles.row, fontWeight: 'bold', color: datosCierre.diferencia === 0 ? '#000' : '#000' }}>
                <span>DIFERENCIA:</span>
                <span>{datosCierre.diferencia > 0 ? '+' : ''}${Number(datosCierre.diferencia).toLocaleString('es-CO')}</span>
            </div>


            {/* --- BLOQUE 2: BANCOS (Dinero digital) --- */}
            <div style={{ borderTop: '1px solid #000', margin: '12px 0' }} />

            <div style={{ ...styles.bold, textAlign: 'center', marginBottom: '6px', textDecoration: 'underline' }}>
                MOVIMIENTOS EN BANCO
            </div>

            <div style={styles.row}>
                <span>(+) VENTAS TRANSF.:</span>
                <span>${Number(datosCierre.ventas_transferencia).toLocaleString('es-CO')}</span>
            </div>

            {Number(datosCierre.abonos_transferencia) > 0 && (
                <div style={styles.row}>
                    <span>(+) ABONOS TRANSF.:</span>
                    <span>${Number(datosCierre.abonos_transferencia).toLocaleString('es-CO')}</span>
                </div>
            )}

            {Number(datosCierre.devoluciones_transferencia) > 0 && (
                <div style={styles.row}>
                    <span>(-) DEV. DIGITAL (Bancos):</span>
                    <span>-${Number(datosCierre.devoluciones_transferencia).toLocaleString('es-CO')}</span>
                </div>
            )}

            <div style={{ ...styles.row, ...styles.bold, marginTop: '4px', paddingTop: '4px', borderTop: '1px dotted #888' }}>
                <span>NETO EN BANCOS:</span>
                <span>${(Number(datosCierre.ventas_transferencia) + Number(datosCierre.abonos_transferencia || 0) - Number(datosCierre.devoluciones_transferencia || 0)).toLocaleString('es-CO')}</span>
            </div>


            {/* --- BLOQUE 3: RESUMEN GLOBAL --- */}
            <div style={{ borderTop: '1px solid #000', margin: '12px 0' }} />

            <div style={{ ...styles.bold, textAlign: 'center', marginBottom: '6px' }}>
                RESUMEN DE VENTAS BRUTAS
            </div>

            <div style={styles.row}>
                <span>VENTAS EN EFECTIVO:</span>
                <span>${Number(datosCierre.ventas_efectivo).toLocaleString('es-CO')}</span>
            </div>
            <div style={styles.row}>
                <span>VENTAS EN BANCOS:</span>
                <span>${Number(datosCierre.ventas_transferencia).toLocaleString('es-CO')}</span>
            </div>
            {Number(datosCierre.ventas_credito) > 0 && (
                <div style={styles.row}>
                    <span>VENTAS A CRÉDITO (FIADO):</span>
                    <span>${Number(datosCierre.ventas_credito).toLocaleString('es-CO')}</span>
                </div>
            )}

            <div style={{ borderTop: '1px dotted #888', margin: '4px 0' }} />

            <div style={{ ...styles.row, ...styles.bold, fontSize: tamañoFuenteTitulo }}>
                <span>TOTAL VENTAS BRUTAS:</span>
                <span>${Number(datosCierre.ventas_totales).toLocaleString('es-CO')}</span>
            </div>

            {/* --- OBSERVACIONES Y PIE DE TICKET --- */}
            {datosCierre.observaciones && (
                <div style={{ marginTop: '12px', fontSize: tamañoFuentePequena, fontStyle: 'italic', borderTop: '1px dotted #888', paddingTop: '6px' }}>
                    OBS: {datosCierre.observaciones}
                </div>
            )}

            <div style={{ textAlign: 'center', fontSize: tamañoFuentePequena, marginTop: '15px' }}>
                <p style={{ marginTop: '6px', letterSpacing: '0.5px', ...styles.bold, color: '#000', fontWeight: '600' }}>*** FIN DEL REPORTE ***</p>
            </div>

            <div style={{ height: '10mm' }}></div>
        </div>
    );
});

TicketCierreCaja.displayName = 'TicketCierreCaja';